import i18n from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setPageBlocker } from '../../../redux/common/CommonActions';
import { usePageCallbackPrompt } from '../../../redux/hooks/usePageCallbackPrompt';
import ConfirmationModal from './ConfirmationModal';

const PageBlockerModal = () => {
  const dispatch = useDispatch();
  const isPageBlocking = useSelector((state) => state?.common?.pageBlocker);
  const [showPrompt, confirmNavigation, cancelNavigation] = usePageCallbackPrompt(isPageBlocking);
  const onConfirmNavigation = () => {
    confirmNavigation();
    dispatch(setPageBlocker(false));
  };

  return (
    <ConfirmationModal
      title={i18n.t('translation:default.fields.alert')}
      open={showPrompt}
      description={i18n.t('translation:default.fields.unsavedChanges')}
      onOk={onConfirmNavigation}
      onClose={cancelNavigation}
      onCancel={cancelNavigation}
    />
  );
};

export default PageBlockerModal;
